import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-delete-confirmation',
  templateUrl: './delete-confirmation.component.html',
  styleUrls: ['./delete-confirmation.component.scss']
})
export class DeleteConfirmationComponent implements OnChanges, OnDestroy {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() isConfirmDisabled: boolean = false;
  @Input() confirmButtonSuffix: string = '';
  @Input() confirmButtonText: string = 'Move to Trash';
  @Input() deleteMessage: string = '';
  @Input() title: string = 'Are you sure you want to delete this?';

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  countdown = 0;
  internalDisabled = true;
  private countdownSub: Subscription | null = null;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && changes['visible'].currentValue === true) {
      this.startCountdown();
    }
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  private startCountdown(): void {
    this.stopCountdown();
    this.internalDisabled = true;
    this.countdown = 5;
    this.countdownSub = interval(1000)
      .pipe(take(6))
      .subscribe({
        next: (value) => {
          this.countdown = 5 - value;
          this.cdRef.detectChanges();
        },
        complete: () => {
          this.countdown = 0;
          this.internalDisabled = false;
          this.cdRef.detectChanges();
        }
      });
  }

  private stopCountdown(): void {
    if (this.countdownSub) {
      this.countdownSub.unsubscribe();
      this.countdownSub = null;
    }
  }

  get isDisabled(): boolean {
    return this.internalDisabled || this.isConfirmDisabled;
  }

  get buttonSuffix(): string {
    if (this.confirmButtonSuffix) {
      return this.confirmButtonSuffix;
    }
    return this.countdown > 0 ? ' (' + this.countdown + ')' : '';
  }

  get confirmButtonLabel(): string {
    return this.confirmButtonText || 'Move to Trash';
  }

  get deleteMessageText(): string {
    return (
      this.deleteMessage ||
      'Deleting this item will move it to the Trash, where it will be stored for 30 days before being permanently removed. Would you like to continue?'
    );
  }

  onCancel(): void {
    this.stopCountdown();
    this.visible = false;
    this.visibleChange.emit(false);
    this.cancel.emit();
  }

  onConfirm(): void {
    this.stopCountdown();
    this.confirm.emit();
  }
}
